import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import { Box } from "@mui/material";
import ProgressCom from "../../../components/ProgressCom";
import CustomPagination from "../../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import ClearIcon from "@mui/icons-material/Clear";
import { UseDiscountCode } from "./UseDiscountCode";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteRow from "../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import CategoryAutoComplete from "../../../basic-information/productCategory/CategoryAutoComplete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function CodeCategory(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const {
    getDiscountCodeCategory,
    addDiscountCodeCategory,
    deleteDiscountCodeCategory,
  } = UseDiscountCode();
  const [categories, setCategories] = useState([]);
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [name, setName] = useState("");

  const [addcategory, setAddcategory] = useState(false);
  const [stateAdd, setStateAdd] = useState({
    discountID: props.DiscountID,
    categoryID: "",
  });

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    if (props.DiscountID) {
      setProgress(true);
      getDiscountCodeCategory(props.DiscountID, (callback) => {
        setCategories(callback);
      });
    }
  }, [props.DiscountID]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "categoryName",
      width: 180,
      align: "center",
      headerName: "نام دسته",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.categoryName}
          </Typography>
        );
      },
    },
    {
      field: "حذف",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setDeleteState({
                show: true,
                name: cellValues.row.categoryID,
                id: cellValues.row.id,
              });
            }}
          >
            <DeleteIcon sx={{ color: "MyColor.main" }} />
          </IconButton>
        );
      },
    },
    {
      field: "addcategory",
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setAddcategory(true);
            }}
          >
            <AddCircleIcon sx={{ color: "primary.main" }} />
          </IconButton>
        );
      },
    },
  ];

  return (
    <Dialog
      PaperProps={
        {
          // elevation: 1,
        }
      }
      sx={{ zIndex: 200 }}
      fullWidth
      open={props.showCategoris}
      onClose={() => props.setShowCategoris(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        sx={{ p: 1, px: 2 }}
        color="secondary"
        id="alert-dialog-title"
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {!addcategory ? (
            <Typography color="secondary" variant="subtitle2">
              لیست دسته ها
            </Typography>
          ) : (
            <Typography variant="subtitle2">دسته را انتخاب کنید</Typography>
          )}
          {!addcategory ? (
            <IconButton
              onClick={() => {
                props.setShowCategoris(false);
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ) : (
            <IconButton
              onClick={() => {
                setAddcategory(false);
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        {!addcategory ? (
          <Box sx={{ height: "18rem" }}>
            {categories ? (
              <DataGrid
                localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
                columns={columns}
                rows={categories ? categories : []}
                page={pageState.page - 1}
                pageSize={20}
                Pagination
                onPageChange={(newPage) => {
                  setPageState((old) => ({ ...pageState, page: newPage + 1 }));
                }}
                rowCount={
                  categories && categories.length ? categories.length : 1
                }
                disableColumnMenu
                hideFooterSelectedRowCount
                components={{
                  Pagination: CustomPagination,
                }}
                componentsProps={{
                  pagination: {
                    nofab: true,
                    noPageCount: true,
                    rowCount:
                      categories && categories.length ? categories.length : "",
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: "id",
                        sort: "asc",
                      },
                    ],
                  },
                }}
              />
            ) : (
              <ProgressCom></ProgressCom>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CategoryAutoComplete
              setName={setName}
              selectedCategoryID={stateAdd.categoryID}
              setter={setStateAdd}
              lvl1State={stateAdd}
              Offer
            ></CategoryAutoComplete>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                sx={{ mr: 2 }}
                onClick={() => {
                  if (!stateAdd.categoryID) {
                    enqueueSnackbar("دسته را انتخاب کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  addDiscountCodeCategory(stateAdd, () => {
                    setProgress(true);
                    getDiscountCodeCategory(stateAdd.discountID, (callback) => {
                      setCategories(callback);
                    });
                    props.callback(props.DiscountID);
                    setAddcategory(false);
                    setStateAdd({ ...stateAdd, categoryID: "" });
                  });
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    if (!stateAdd.categoryID) {
                      enqueueSnackbar("دسته را انتخاب کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                        preventDuplicate: true,
                      });
                      return;
                    }
                    addDiscountCodeCategory(stateAdd, () => {
                      setProgress(true);
                      getDiscountCodeCategory(
                        stateAdd.discountID,
                        (callback) => {
                          setCategories(callback);
                        }
                      );
                      props.callback(props.DiscountID);
                      setAddcategory(false);
                      setStateAdd({ ...stateAdd, categoryID: "" });
                    });
                  }
                }}
              >
                ثبت
              </Button>
              <Button
                onClick={() => props.setShowCategoris(false)}
                color="secondary"
                variant="outlined"
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"دسته"}
          callback={() => {
            setProgress(true);
            deleteDiscountCodeCategory(deleteState.id, () => {
              getDiscountCodeCategory(props.DiscountID, (callback) => {
                props.callback(props.DiscountID);
                setCategories(callback);
              });
            });
          }}
        ></DeleteRow>
      </DialogContent>
    </Dialog>
  );
}
